import React, { Component } from 'react'
import { Col, Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { INTERVALO_MEDIO, INTERVALO_CORTO } from '../../../config/settings'
import AsignacionCerealAVolcadora from './AsignacionCerealAVolcadora'

import TareaMovimiento from './TareaMovimiento'
import LecturaSilos from './LecturaSilos'
import { ToastContainer } from 'react-toastify'
import TablaCamionesEnCircuito from '../../Dashboard/components/camionesEnCircuito/containers/TablaCamionesEnCircuito'

class CuadroDeMandoMovimientos extends Component {
  componentDidMount () {
    this.props.lecturaSilos()
    this.intervalValores = setInterval(() => {
      this.props.lecturaSilos()
    }, INTERVALO_MEDIO)
  }

  componentWillUnmount () {
    clearInterval(this.intervalValores)
  }

  render () {
    const { camionesCircuito, valoresSilo } = this.props
    console.log(' camiones', camionesCircuito)

    return (
      <Container fluid>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Col>
          <h2 style={{ margin: '0 auto 2% auto' }}>
              Cuadro de Mando de Movimiento
          </h2>
        </Col>
        <TablaCamionesEnCircuito />
        <div className='container-configuracion-movimiento'>

          <div className='asignacion-cereal-volcadora'>
            {valoresSilo && <LecturaSilos valoresSilo={valoresSilo.split(',')} /> }
            <AsignacionCerealAVolcadora />
          </div>
          <div className='container-tareas-silos'>

            <div className='tareas-movimiento'>
              <TareaMovimiento />
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    camionesCircuito: state.camionesIngreso.totalCamionesCereal,
    valoresSilo: state.cuadroDeMandoMovimientos.valoresSilo
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(CuadroDeMandoMovimientos)
